import { SuSyApi } from '../api/susyApi';
import { ExtensionRequestFileOfProofType } from './utils';

export const generateImageUrl = async (
    imageName: string,
    imageType: string
) => {
    if (imageType && imageName) {
        const result = await SuSyApi.get(
            `/images/get/${imageType}/${imageName}`,
            { responseType: 'blob' }
        );
        return URL.createObjectURL(result.data);
    }
    return '';
};

export const generateExtensionRequestDocumentUrl = (
    fileId: string | null,
    extensionRequestId: string | null,
    extensionRequestType: ExtensionRequestFileOfProofType | null
) => {
    const routeType =
        extensionRequestType === ExtensionRequestFileOfProofType.AcademicReason
            ? 'getAcademicFileById'
            : 'getDoctorFileById';

    if (!fileId) {
        return '';
    }
    return `/extensionRequest/${extensionRequestId}/${routeType}/${fileId}`;
};

export const generateDocumentUrl = (
    fileId: string | null,
    projectId: string | null
) => {
    if (!fileId) {
        return '';
    }
    return `/project/${projectId}/getFileById/${fileId}`;
};

export const generateAdminDocumentUrl = (
    adminDocumentId: string | undefined
) => {
    if (!adminDocumentId) {
        return '';
    }
    return `/adminDocument/${adminDocumentId}`;
};

export const generateArchiveDocumentUrl = (
    fileId: string | null,
    projectId: string | null
) => {
    if (!fileId) {
        return '';
    }
    return `/archive/project/${projectId}/getFileById/${fileId}`;
};

export const generateExternalSupervisorDocumentUrl = (
    fileId: string | undefined | null,
    externalSupervisor: string | undefined
) => {
    if (!fileId) {
        return '';
    }
    return `/user/${externalSupervisor}/getFileById/${fileId}`;
};

export const generateHelpFileUrl = (fileId: string) => {
    return `/helpFile/${fileId}`;
};

export const generatePublicFileUrl = (fileId: string) => {
    return `/public/${fileId}`;
};
